(function (Drupal) {
  Drupal.behaviors.formward = { 
    attach: function (context, settings) {
      const cta_back = document.querySelector('#block-subtheme-keralty-back a , #block-subtheme-keralty-back-2 a', context);
      
      if (cta_back) {
        cta_back.addEventListener("click", function(event) { 
          history.back();
        });
      }
    }
  };
})(Drupal);
  